export default __webpack_public_path__ + "static/media/users-actives.92fcb4cf.svg";